// src/pages/Home/homeData.js

import { FaGlobe, FaFlask, FaBox, FaChartPie } from "react-icons/fa";

/**
 * 1) Your slider items (videos, names, descs, categories — from your CDN)
 */
export const categoryImages = [
  {
    id: 1,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mutfak.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mutfak.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/mutfak.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/mutfak.webm",
    name: "kitchen", // Translation key
    category: "mutfak",
    description: "kitchen", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mutfak.jpg"
  },
  {
    id: 2,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/bina_bakimi.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/bina_bakimi.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/bina_bakimi.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/bina_bakimi.webm",
    name: "building_maintenance", // Translation key
    category: "bina-bakimi",
    description: "building_maintenance", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/bina_bakimi.jpg"
  },
  {
    id: 3,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/kisisel.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/kisisel.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/kisisel.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/kisisel.webm",
    name: "personal_hygiene", // Translation key
    category: "kisisel-hijyen",
    description: "personal_hygiene", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/kisisel.jpg"
  },
  {
    id: 4,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/camasir.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/camasir.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/camasir.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/camasir.webm",
    name: "laundry", // Translation key
    category: "camasir",
    description: "laundry", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/camasir.jpg"
  },
  {
    id: 5,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/gida_hijyen.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/gida_hijyen.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/gida_hijyen.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/gida_hijyen.webm",
    name: "food_hygiene", // Translation key
    category: "gida-hijyeni",
    description: "food_hygiene", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/gida_hijyen.jpg"
  },
  {
    id: 6,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/dezenfektanlar.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/dezenfektanlar.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/dezenfektanlar.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/dezenfektanlar.webm",
    name: "disinfectants", // Translation key
    category: "dezenfektanlar-ve-antiseptikler",
    description: "disinfectants", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/dezenfektanlar.jpg"
  },
  {
    id: 7,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/ozel_urunler.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/ozel_urunler.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/ozel_urunler.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/ozel_urunler.webm",
    name: "special_products", // Translation key
    category: "ozel-urunler",
    description: "special_products", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/ozel_urunler.jpg"
  },
  {
    id: 8,
    image: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/endustriyel.mp4",
    webm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/endustriyel.webm",
    mobileImage: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/endustriyel.mp4",
    mobileWebm: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/mobile/endustriyel.webm",
    name: "industrial_chemistry", // Translation key
    category: "endustriyel-kimya",
    description: "industrial_chemistry", // Translation key
    poster: "https://krl-kimya.fra1.cdn.digitaloceanspaces.com/videos/endustriyel.jpg"
  },
];


/**
 * 2) Your brands data (local images + feature lists)
 */
export const brands = [
  {
    id: 1,
    features: [
      "Sektör ihtiyaçlarına odaklı",
      "Konsantre ve ekonomik",
      "Çevreye duyarlı",
      "Pratik ve kolay kullanım",
    ],
    image: "/images/equinox_logo.png",
  },
  {
    id: 2,
    features: [
      "Gıda üretim tesislerinde hijyen",
      "Seyreltme sistemlerine uygun",
      "Yüksek konsantrasyon",
    ],
    image: "/images/endaxi_logo.png",
  },
  {
    id: 3,
    features: [
      "Sıvı ve toz endüstriyel çamaşır yıkama ürünleri",
      "Düşük su sıcaklıklarında etkin çözümler",
      "Yüksek konsantrasyon",
    ],
    image: "/images/lora_logo.png",
  },
  {
    id: 4,
    features: [
      "Sanayi üretim tesislerinde endüstriyel çözümler",
      "Bakım ve koruma kimyasalları",
      "Pratik ve kolay kullanım, hızlı çözümler",
    ],
    image: "/images/chemiccount_logo.png",
  },
];


/**
 * 3) Your certificates (local logo + CDN-hosted PDF)
 */
export const certificates = [
  {
    logo: "/images/certificate-logo1.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate1.pdf",
  },
  {
    logo: "/images/certificate-logo2.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate2.pdf",
  },
  {
    logo: "/images/certificate-logo3.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate3.pdf",
  },
  {
    logo: "/images/certificate-logo5.png",
    pdf: "https://fra1.digitaloceanspaces.com/krl-kimya/certificates/certificate4.pdf",
  },
  // …etc
];

/**
 * 4) Your stats counters
 */
export const statsData = [
  {
    id: 1,
    icon: <FaGlobe />,
    targetNumber: 500,
    label: "customers", // Translation key
    backgroundColor: "#3498db",
    suffix: "+",
    start: 0,
  },
  {
    id: 2,
    icon: <FaFlask />,
    targetNumber: 60000,
    label: "production", // Translation key
    backgroundColor: "#2471a3",
    suffix: "+",
    start: 10000, // Start from 20,000 for faster counting
  },
  {
    id: 3,
    icon: <FaBox />,
    targetNumber: 500,
    label: "products", // Translation key
    backgroundColor: "#2471a3",
    suffix: "+",
    start: 0,
  },
  {
    id: 4,
    icon: <FaChartPie />,
    targetNumber: 40,
    label: "export", // Translation key
    backgroundColor: "#1f618d",
    suffix: "%",
    start: 0,
  },
];

/**
 * 5) Your references (46 logos on CDN + optional names)
 */
export const references = Array.from({ length: 46 }, (_, idx) => ({
  id: idx + 1,
  logo: `https://krl-kimya.fra1.digitaloceanspaces.com/references/reference${
    idx + 1
  }.png`,
  name: `Company Name ${idx + 1}`, // replace if you have real names
}));
